// @ts-check

import { anyCharExcept, between, choice, many, str } from 'arcsecond';

/** @param {string} name */
const customTag = name => (
  between(str(`<${name}>`))(str(`</${name}>`))(
    many(anyCharExcept(str(`</${name}>`)))
      .map(chars => chars.join(""))
  )
)

const $reasoningTag = customTag("rs")
const $reportGenerationTag = customTag("rg")

const $customTag = choice([
  $reasoningTag.map(tag => ({
    type: /**@type{const}*/("reasoning_tag"),
    content: tag,
  })),
  $reportGenerationTag.map(tag => ({
    type: /**@type{const}*/("report_generation_tag"),
    content: tag,
  })),
])

const textWithCustomTags = many(
  choice([
    $customTag,
    many(anyCharExcept($customTag)).map(chars => ({
      type: /**@type{const}*/("raw_text"),
      content: chars.join(""),
    })),
  ])
)

/**
 * @param {import('arcsecond').ResultType<any, string, any>} result
 * @returns {result is {isError: true}}
 */
const isErrorParseResult = (result) => result.isError

/** @param {string} text */
function parseAgentTextResponse(text) {
  const result = textWithCustomTags.run(text)
  if(isErrorParseResult(result)) throw new Error(result.error)
  return result.result
}

export {
  parseAgentTextResponse,
}